import { render, staticRenderFns } from "./GroupLocations.vue?vue&type=template&id=70df4ab0&scoped=true&"
import script from "./GroupLocations.vue?vue&type=script&lang=js&"
export * from "./GroupLocations.vue?vue&type=script&lang=js&"
import style0 from "./GroupLocations.vue?vue&type=style&index=0&id=70df4ab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df4ab0",
  null
  
)

export default component.exports